'use client';

import React from 'react';
import { EChartsOption } from 'echarts-for-react';

import { HistoryChartSkeleton } from './HistoryChartSkeleton';

const ReactECharts = React.lazy(() => import('echarts-for-react'));

interface HistoryChartProps {
  chartOptions: EChartsOption | null;
  isLoadingChart: boolean;
}

export const HistoryChart = ({ chartOptions, isLoadingChart }: HistoryChartProps) => (
  <div
    className={chartOptions || isLoadingChart ? 'h-[220px] overflow-hidden bg-bzblue-700' : 'h-px bg-bzblue-700'}
    aria-hidden={!chartOptions && !isLoadingChart}
  >
    {chartOptions ? (
      <React.Suspense fallback={<HistoryChartSkeleton />}>
        <ReactECharts
          option={chartOptions}
          style={{ height: '220px', width: '100%' }}
          opts={{ renderer: 'canvas' }}
        />
      </React.Suspense>
    ) : isLoadingChart ? (
      <HistoryChartSkeleton />
    ) : null}
  </div>
);
